import View, { ViewOpts } from '@play-co/timestep-core/lib/ui/View';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import TilingBackground from 'src/game/minigame/match2-timestep/team/components/TilingBackground';

export class BuddiesBackground extends View {
  private tiles: TilingBackground;
  private background: ImageScaleView;

  constructor(opts: ViewOpts) {
    super({ ...opts, clip: true });

    this.tiles = new TilingBackground({
      tileOpts: {
        image: 'assets/ui/buddies/common/bg_tile.png',
        columns: 4,
      },
      maskOpts: {
        superview: this,
        width: this.style.width,
        height: this.style.height,
      },
      movementOpts: {
        speed: -2,
        direction: 'diagonal',
      },
    });

    this.background = new ImageScaleView({
      superview: this,
      opacity: 0.8,
      image: 'assets/ui/buddies/common/bg.png',
      width: this.style.width,
      height: this.style.height,
      scaleMethod: 'stretch',
    });
  }
}
